<!-- EditUniverseModal.vue -->
<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Load a Universe</p>
      <button
        type="button"
        class="delete"
        v-on:click="$parent.close()"/>
    </header>
    <div class="modal-card-body">
      <p>
        Select one of your portfolios, or any available fund, to use as your universe.
      </p>
      <b-tabs v-model="activeTab">
        <b-tab-item label="Portfolios">
          <p v-show="modelPortfolios.loaded && modelPortfolios.a.length === 0">
            You have no Model Portfolios, please create one in the Advisor Dashboard.
          </p>
          <div v-show="!modelPortfolios.loaded || modelPortfolios.a.length > 0">
            <p>Choose a Model Portfolio to use as a universe:</p>

            <!-- Search Input -->
            <b-field>
              <b-input 
                v-model="searchQuery" 
                placeholder="Search Portfolios..." 
                @input="loadModelPortfolios(1, searchQuery)" 
                debounce="500"
              />
            </b-field>

            <!-- Table without built-in pagination -->
            <b-table
              v-bind:data="modelPortfolios.a"
              v-bind:loading="!modelPortfolios.loaded"
              :paginated="false"
              icon-pack="fas"
            >
              <b-table-column field="nickname" label="Name" sortable v-slot="props">
                {{ props.row.nickname }}
              </b-table-column>
              <b-table-column field="updated_at" label="Last Updated" sortable v-slot="props">
                {{ new Date(props.row.updated_at).toLocaleString() }}
              </b-table-column>
              <b-table-column field="company_count" label="Public Companies" sortable v-slot="props">
                {{ props.row.company_count }}
              </b-table-column>
              <b-table-column field="name" label="Loading Options" sortable v-slot="props">
                <b-tooltip label="This looks at directly held equities, and optimizations will also preserve weightings of loaded bond funds" position="is-left" multilined>
                  <a v-on:click="$root.$emit('universe-changed', 'model_portfolio_direct', props.row.id, props.row.nickname); $parent.close()">
                    Standard Loading
                  </a>
                </b-tooltip>
                <br>
                ------------
                <b-tooltip label="This aggregates the holdings of the equity funds into a universe of direct equities" position="is-left" multilined>
                  <a v-on:click="$root.$emit('universe-changed', 'model_portfolio', props.row.id, props.row.nickname); $parent.close()">
                    Lookthrough Fund Holdings
                  </a>
                </b-tooltip>
              </b-table-column>
            </b-table>

            <!-- Separate pagination component -->
            <b-pagination
              v-model="modelPortfolios.currentPage"
              :total="modelPortfolios.total"
              :per-page="10"
              @change="page => loadModelPortfolios(page, searchQuery)"
            />
          </div>
        </b-tab-item>

        <b-tab-item label="Funds" class="fund-search-tab">
          <TypeaheadFundSearch
            v-bind:callback="fundSelectCallback"
          />
          <br>
          <p class="help is-small">
            <strong>Disclaimer</strong><br>
          </p>
          <p class="help">
            Fund holdings are filed with the Securities and Exchange Commission on a quarterly basis, and are updated on YourStake within one month after the filing date. New funds and companies become accessible on YourStake when sufficient data is available. New funds become available on YourStake approximately one month after first filing their holdings with the Securities and Exchange Commission. New companies become available on YourStake approximately 6 months after their IPO.
          </p>
          <b-table
            v-bind:data="selectedFunds"
            icon-pack="fas"
          >
            <b-table-column field="ticker.symbol" label="Ticker" v-slot="props">
              {{ props.row.ticker.symbol }}
            </b-table-column>
            <b-table-column field="ticker.full_name" label="Full Name" v-slot="props">
              {{ props.row.ticker.full_name }}
            </b-table-column>
            <b-table-column v-slot="props">
              <button @click="unselectFund(props.row)" class="button is-small">
                Remove
              </button>
            </b-table-column>
          </b-table>
          <div class="button is-primary" @click="submitFunds">Submit</div>
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>

import TypeaheadFundSearch from '@frontend/shared/components/TypeaheadFundSearch.vue';

export default {
  data() {
    return {
      activeTab: 0,
      searchQuery: '',
      selectedFunds: [],
      modelPortfolios: {
        a: [],
        loaded: false,
        total: 0,
        currentPage: 1,
      }
    };
  },
  components: {
    TypeaheadFundSearch,
  },
  props: {
    parent: Object,
  },
  mounted() {
    this.loadModelPortfolios();
  },
  methods: {
    // Load portfolios with pagination & search
    loadModelPortfolios(page = 1, search = '') {
      console.error('Loading model portfolios');
      this.modelPortfolios.loaded = false;
      fetch(`/api/v1/model_portfolios/?page=${page}&page_size=10&search=${search}`)
        .then(response => response.json())
        .then(data => {
          this.modelPortfolios.a = data.results;
          this.modelPortfolios.total = data.count;
          this.modelPortfolios.currentPage = page;
          this.modelPortfolios.loaded = true;
        });
    },

    fundSelectCallback(fund) {
      if (this.selectedFunds.find(selectedFund => selectedFund.ticker.id === fund.ticker.id)) {
        return;
      }
      this.selectedFunds.push(fund);
    },
    unselectFund(fund) {
      this.selectedFunds = this.selectedFunds.filter(selectedFund => selectedFund.ticker.id !== fund.ticker.id);
    },
    submitFunds() {
      if (!this.selectedFunds.length) {
        this.$parent.close();
        return;
      }
      const tickerSymbols = this.selectedFunds.map(fund => fund.ticker.symbol);
      const stringToSend = tickerSymbols.join(',');
      const stringToDisplay = tickerSymbols.join('/');
      this.$root.$emit('universe-changed', 'fund', stringToSend, stringToDisplay);
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss">
.fund-search-tab {
  min-height: 600px;
}
</style>
